"use client";

import { ArrowUpRight } from "lucide-react";
import { useTranslations } from "next-intl";
import { Link, usePathname } from "@/i18n/routing";
import { cn } from "@/lib/cn";

/**
 * Local sub-navigation for the Transportpartner cluster. Sticks just below the
 * site header and links the four content pages, with the registration CTA on
 * the right. Labels come from the `TransportpartnerNav` uiStrings namespace
 * (all 17 locales seeded via scripts/add-transportpartner-nav-strings.ts).
 * Active state via the locale-stripped pathname (exact match).
 */
const LINKS = [
  { href: "/transportpartner", key: "overview" },
  { href: "/transportpartner/faq", key: "faq" },
  { href: "/transportpartner/anforderungen", key: "requirements" },
  { href: "/transportpartner/abrechnung", key: "billing" },
] as const;

export function TransportpartnerSubnav() {
  const t = useTranslations("TransportpartnerNav");
  const pathname = usePathname();
  return (
    <nav
      aria-label="Transportpartner"
      // Offsets = full sticky-header height: h-16 main row (<md), plus the
      // h-10 UtilityBar from md, main row 4.25rem from lg. With plain top-16
      // the bar slid UNDER the header (z-40 vs z-30) and looked gone.
      className="sticky top-16 z-30 border-b border-line-200 bg-canvas/95 backdrop-blur supports-[backdrop-filter]:bg-canvas/80 md:top-[6.5rem] lg:top-[6.75rem]"
    >
      <div className="container flex h-12 items-center gap-1 overflow-x-auto">
        {LINKS.map((l) => {
          const active = pathname === l.href;
          return (
            <Link
              key={l.href}
              href={l.href}
              aria-current={active ? "page" : undefined}
              className={cn(
                "shrink-0 rounded-md px-3 py-1.5 text-sm font-medium transition-colors",
                active
                  ? "bg-soft text-ink-900"
                  : "text-ink-600 hover:bg-soft hover:text-ink-900",
              )}
            >
              {t(l.key)}
            </Link>
          );
        })}
        <Link
          href="/transportpartner/registrierung"
          className="btn-ghost ml-auto hidden shrink-0 !min-h-0 py-1.5 sm:inline-flex"
        >
          {t("registerCta")}
          <ArrowUpRight className="h-3.5 w-3.5" aria-hidden />
        </Link>
      </div>
    </nav>
  );
}
